import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpDownOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.99 9.51 3 10.5l5 5 5-5-.99-.99L8 13.52z"
                    fill="currentColor"
                />
                <path d="m8 .5 5 5-.99.99L8 2.48 3.99 6.49 3 5.5z" fill="currentColor" />
            </g>
        </svg>
    )
);
ChevronUpDownOutlinedSize16Glyph.displayName = 'ChevronUpDownOutlinedSize16Glyph';
